const pushParam = (params, label, value) => {
    if (value != null && value !== '') {
        params.push({ label, value: String(value) });
    }
};

// Vidura is an iron-condor lockbox: each position carries up to four legs
// (SC/SP short, LC/LP long) keyed by leg_role with a CE/PE side, strike,
// instrument symbol, entry price and per-leg slippage points.
const mapViduraLeg = (leg = {}) => {
    const role = leg.role ?? leg.legRole ?? leg.leg_role ?? null;
    const side = leg.side ?? null;
    const strike = leg.strike ?? null;
    const symbol = leg.symbol ?? null;
    const entryPrice = leg.entryPrice ?? leg.entry_price ?? null;
    const slipPts = leg.slipPts ?? leg.slip_pts ?? null;
    const qty = leg.qty ?? leg.quantity ?? null;
    return {
        ...leg,
        role,
        side,
        strike,
        symbol,
        entryPrice,
        slipPts,
        qty,
    };
};

export function mapViduraPosition(position = {}, labels = {}) {
    const legs = Array.isArray(position.legs) ? position.legs.map(mapViduraLeg) : [];

    const params = Array.isArray(position.params) && position.params.length
        ? position.params
        : (() => {
            const fallback = [];
            pushParam(fallback, 'Expiry', position.expiry);
            pushParam(fallback, 'Credit', position.credit);
            pushParam(fallback, 'Legs', legs.length || null);
            return fallback;
        })();

    return {
        ...position,
        legs,
        strategyLabel: labels.strategyLabel || position.strategyId,
        clientAlias: labels.clientAlias || position.clientId,
        params,
    };
}
